import React, { useState } from "react";
import { API_BASE_URL } from "../../../config";

function PostCleaningListing() {
  const [message, setMessage] = useState("");

  


  // ================================
  // BASIC LOCATION
  // ================================
  const [suburb, setSuburb] = useState("");
  const [state, setState] = useState("");
  const [postcode, setPostcode] = useState("");

  // ================================
  // CLIENT OVERVIEW
  // ================================
  const [accessType, setAccessType] = useState("Access Available Anytime");
  const [streetParking, setStreetParking] = useState(false);
  const [petsAtHome, setPetsAtHome] = useState(false);
  const [alarmCodeRequired, setAlarmCodeRequired] = useState(false);
  const [homeSize, setHomeSize] = useState("");

  // ================================
  // SERVICE PREFERENCES
  // ================================
  const [serviceDay, setServiceDay] = useState("any");
  const [serviceTime, setServiceTime] = useState("any");

  // ================================
  // JOB DETAILS
  // ================================
  const [cleaningTime, setCleaningTime] = useState("");
  const [frequency, setFrequency] = useState("fortnightly");

  // ================================
  // AREAS SERVICED
  // ================================
  const [bedroomsCleaned, setBedroomsCleaned] = useState(1);
  const [bathroomsCleaned, setBathroomsCleaned] = useState(1);
  const [toiletsCleaned, setToiletsCleaned] = useState(1);
  const [kitchenIncluded, setKitchenIncluded] = useState(true);
  const [livingAreasIncluded, setLivingAreasIncluded] = useState(true);

  const [newClient, setNewClient] = useState(false);
const [longTermClient, setLongTermClient] = useState(false);

  // ================================
  // ROUTINE CLEANING SERVICES
  // ================================
  const [services, setServices] = useState({
    dusting: true,
    vacuuming: true,
    mopping: true,
    surfacesWiped: true,
    tidying: true,
    kitchenCleaning: true,
    bathroomCleaning: true,
    bedMaking: false,
    linenChanging: false,
    washing: false,
    ironing: false,
    pantryTidying: false,
    loungeVacuum: false,
    cobwebRemoval: false,
    lightSpotCleaning: false,
    dishwashing: false,
    organisation: false,
  });

  const toggleService = (key) => {
    setServices((prev) => ({ ...prev, [key]: !prev[key] }));
  };

  // ================================
  // PRICING
  // ================================

  const [avgJobPrice, setAvgJobPrice] = useState("");
  const [salePrice, setSalePrice] = useState("");
  const [promoCode, setPromoCode] = useState("");

  // DISCLAIMER
  const [disclaimerAccepted, setDisclaimerAccepted] = useState(false);

  // ================================
  // LISTING CONSTANTS
  // ================================
  const category = "Cleaning";
  const type = "Sell";
  const title = "Cleaning Client Listing";



  // ================================
  // CLN-#### ID GENERATOR
  // ================================
  const generateListingId = () => {
    return `CLN-${Math.floor(1000 + Math.random() * 9000)}`;
  };

  // ================================
  // SUBMIT HANDLER
  // ================================
 const handleSubmit = async (e) => {
  e.preventDefault();
  setMessage("");

  try {
    const token = localStorage.getItem("token");
    const user = JSON.parse(localStorage.getItem("user"));

    if (!user?.id) {
      setMessage("❌ You must be logged in to post a listing.");
      return;
    }

    const listingId = generateListingId();

    const payload = {
      listingId,
      user_id: user.id,

      suburb,
      state,
      postcode,

      accessType,
      streetParking,
      petsAtHome,
      alarmCodeRequired,
      homeSize,

      serviceDay,
      serviceTime,

      cleaningTime,
      frequency,

      bedroomsCleaned,
      bathroomsCleaned,
      toiletsCleaned,
      kitchenIncluded,
      livingAreasIncluded,
      newClient,
      longTermClient,

      services,

    
      avgJobPrice,
      salePrice,

      
  disclaimerAccepted: disclaimerAccepted ? 1 : 0, // ⭐ THIS LINE

      listing_status: "pending",
    };

    // 1️⃣ CREATE CLEANING LISTING
    const res = await fetch(`${API_BASE_URL}/api/cleaning/listings/create`, {


      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(payload),
    });

    const data = await res.json();

    if (!res.ok || !data.listingId) {
      alert(data.error || "Failed to create cleaning listing");
      return;
    }

    // 2️⃣ START CLEANING ACTIVATION PAYMENT (25%)
    const paymentRes = await fetch(
      `${API_BASE_URL}/api/cleaning/payment/create-listing-fee`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
          listingId: data.listingId,
          price: Number(salePrice),   // MUST be sale price
          userId: user.id,
          email: user.email,
          title: "Cleaning Client",
          promoCode,
        }),
      }
    );

    const paymentData = await paymentRes.json();


    if (!paymentRes.ok) {
  alert(paymentData.error || "Failed to start activation flow");
  return;
}

if (paymentData.free) {
  alert("✅ Your cleaning listing is now live (free launch)");
  window.location.href = "/my-listings";
  return;
}

if (!paymentData.url) {
  alert(paymentData.error || "Failed to start activation payment");
  return;
}
 // 🚀 REDIRECT TO STRIPE (ONLY ONCE)
window.location.href = paymentData.url;

  } catch (err) {
    console.error("❌ Error posting cleaning listing:", err);
    setMessage("❌ Server error. Please try again.");
  }
};


  // ================================
  // UI
  // ================================
  return (
    <div style={container}>
      <h2 style={pageHeader}>Post Cleaning Listing</h2>

      {message && (
        <div
          style={{
            marginBottom: "20px",
            textAlign: "center",
            fontWeight: 600,
            color: message.includes("❌") ? "#d32f2f" : "#2e7d32",
          }}
        >
          {message}
        </div>
      )}

      <form onSubmit={handleSubmit} style={form}>

        {/* LOCATION */}
        <h3 style={sectionHeader}>Location</h3>

        <label style={labelBold}>Suburb</label>
        <input style={input} required value={suburb} onChange={(e) => setSuburb(e.target.value)} />

        <label style={labelBold}>State</label>
        <select style={input} required value={state} onChange={(e) => setState(e.target.value)}>
          <option value="">Select</option>
          <option value="VIC">VIC</option>
          <option value="NSW">NSW</option>
          <option value="QLD">QLD</option>
          <option value="SA">SA</option>
          <option value="WA">WA</option>
          <option value="NT">NT</option>
          <option value="TAS">TAS</option>
          <option value="ACT">ACT</option>
        </select>

        <label style={labelBold}>Postcode</label>
        <input style={input} required value={postcode} onChange={(e) => setPostcode(e.target.value)} />

        {/* CLIENT OVERVIEW */}
        <h3 style={sectionHeaderBlue}>Client Overview</h3>

        <label style={labelBold}>Access Type</label>
        <select style={input} value={accessType} onChange={(e) => setAccessType(e.target.value)}>
          <option value="Access Available Anytime">Access Available Anytime</option>
          <option value="Access Requires Client to Be Home">
            Access Requires Client to Be Home
          </option>
          <option value="Access via Key or Gate Code">Access via Key or Gate Code</option>
        </select>

        <Checkbox label="Street Parking Available" value={streetParking} setValue={setStreetParking} />
        <Checkbox label="Pets at Home" value={petsAtHome} setValue={setPetsAtHome} />
        <Checkbox label="Alarm Code Required" value={alarmCodeRequired} setValue={setAlarmCodeRequired} />

        <label style={labelBold}>Home Size (e.g. 3 Bedroom)</label>
        <input style={input} value={homeSize} onChange={(e) => setHomeSize(e.target.value)} />

        {/* SERVICE PREFERENCES */}
        <h3 style={sectionHeader}>Preferred Service</h3>

        <label style={labelBold}>Preferred Day</label>
        <select style={input} value={serviceDay} onChange={(e) => setServiceDay(e.target.value)}>
          <option value="any">Any</option>
          <option value="monday">Monday</option>
          <option value="tuesday">Tuesday</option>
          <option value="wednesday">Wednesday</option>
          <option value="thursday">Thursday</option>
          <option value="friday">Friday</option>
         <option value="saturday">Saturday</option>
          <option value="sunday">Sunday</option>
        </select>

        <label style={labelBold}>Preferred Time</label>
        <select style={input} value={serviceTime} onChange={(e) => setServiceTime(e.target.value)}>
          <option value="any">Any</option>
          <option value="am">Morning</option>
          <option value="pm">Afternoon</option>
        </select>

        {/* JOB DETAILS */}
        <h3 style={sectionHeader}>Job Details</h3>

        <label style={labelBold}>Cleaning Time</label>
        <select style={input} required value={cleaningTime} onChange={(e) => setCleaningTime(e.target.value)}>
          <option value="">Choose Time</option>
          <option value="0.5">30 Minutes</option>
          <option value="1">1 Hour</option>
          <option value="1.5">1.5 Hours</option>
          <option value="2">2 Hours</option>
          <option value="3">3 Hours</option>
        </select>

        <label style={labelBold}>Frequency</label>
        <select style={input} value={frequency} onChange={(e) => setFrequency(e.target.value)}>
          <option value="weekly">Weekly</option>
          <option value="fortnightly">Fortnightly</option>
          <option value="monthly">Monthly</option>
        </select>

        {/* AREAS SERVICED */}
        <h3 style={sectionHeader}>Areas Serviced</h3>

        <label style={labelBold}>Bedrooms Cleaned</label>
        <input type="number" style={input} min="1" value={bedroomsCleaned} onChange={(e) => setBedroomsCleaned(e.target.value)} />

        <label style={labelBold}>Bathrooms Cleaned</label>
        <input type="number" style={input} min="1" value={bathroomsCleaned} onChange={(e) => setBathroomsCleaned(e.target.value)} />

        <label style={labelBold}>Toilets Cleaned</label>
        <input type="number" style={input} min="1" value={toiletsCleaned} onChange={(e) => setToiletsCleaned(e.target.value)} />

        <Checkbox label="Kitchen Included" value={kitchenIncluded} setValue={setKitchenIncluded} />
        <Checkbox label="Living Areas Included" value={livingAreasIncluded} setValue={setLivingAreasIncluded} />

        {/* CLIENT HISTORY */}
<h3 style={sectionHeader}>Client History</h3>

<label style={checkboxRow}>
  <input
    type="checkbox"
    checked={newClient}
    onChange={(e) => {
      const checked = e.target.checked;
      setNewClient(checked);
      if (checked) setLongTermClient(false);
    }}
  />
  New client (under 6 months)
</label>

<label style={checkboxRow}>
  <input
    type="checkbox"
    checked={longTermClient}
    onChange={(e) => {
      const checked = e.target.checked;
      setLongTermClient(checked);
      if (checked) setNewClient(false);
    }}
  />
  Long-term client (12+ months)
</label>

        {/* ROUTINE CLEANING SERVICES */}
        <h3 style={sectionHeaderPurple}>Routine Cleaning Tasks</h3>

        {Object.keys(services).map((key) => (
          <Checkbox
            key={key}
            label={key.replace(/([A-Z])/g, " $1")}
            value={services[key]}
            setValue={() => toggleService(key)}
          />
        ))}

        {/* PRICING */}
        <h3 style={sectionHeaderOrange}>Pricing</h3>


        <label style={labelBold}>Average Job Price ($)</label>
        <input style={input} required value={avgJobPrice} onChange={(e) => setAvgJobPrice(e.target.value)} />

        <label style={labelBold}>Sale Price ($)</label>
        <input style={input} required value={salePrice} onChange={(e) => setSalePrice(e.target.value)} />

        <label style={labelBold}>Promo / Invite Code (Optional)</label>
<input
  style={input}
  type="text"
  placeholder="Optional"
  value={promoCode}
  onChange={(e) => setPromoCode(e.target.value)}
/>

        {/* DISCLAIMER */}
      {/* DISCLAIMER */}
<label style={checkboxRow}>
  <input
    type="checkbox"
    checked={disclaimerAccepted}
    onChange={(e) => setDisclaimerAccepted(e.target.checked)}
    required
  />
  I confirm that:
</label>

<ul style={{ fontSize: "0.9rem", color: "#333", marginTop: "8px", marginLeft: "25px" }}>
  <li>All information provided is accurate and not misleading</li>
  <li>I am solely responsible for this listing</li>
  <li>Client Exchange™ does not verify or guarantee any listing information</li>
  <li>I have authority to transfer this cleaning client</li>
  <li>This does not breach any agreement (including franchise or contractual obligations)</li>
  <li>
  I agree to be bound by the Client Exchange™ terms,
  conditions, and policies listed on the website from time to time
</li>
</ul>

<p style={{ fontSize: "0.8rem", color: "#666", marginTop: "8px" }}>
  Listings must comply with any applicable agreements or obligations held by the seller.
</p>

 <button
  type="submit"
  disabled={!disclaimerAccepted}
  style={{
    ...button,
    backgroundColor: disclaimerAccepted ? "#2e7d32" : "#9e9e9e",
    cursor: disclaimerAccepted ? "pointer" : "not-allowed",
  }}
>
  Submit Cleaning Listing
</button>


      </form>
    </div>
  );
}

// ================================
// REUSABLE CHECKBOX
// ================================
function Checkbox({ label, value, setValue }) {
  return (
    <label style={checkboxRow}>
      <input
        type="checkbox"
        checked={!!value}
        onChange={(e) => setValue(e.target.checked)}
      />
      {label}
    </label>
  );
}

// ================================
// STYLES
// ================================
const container = {
  maxWidth: "650px",
  margin: "40px auto",
  background: "#fff",
  padding: "25px",
  borderRadius: "12px",
  boxShadow: "0 4px 15px rgba(0,0,0,0.15)",
};

const pageHeader = {
  textAlign: "center",
  marginBottom: "25px",
  color: "#2e7d32",
  fontWeight: "bold",
};

const form = { display: "flex", flexDirection: "column", gap: "20px" };
const input = { padding: "10px", borderRadius: "6px", border: "1px solid #ccc" };
const labelBold = { fontWeight: "bold" };

const checkboxRow = {
  display: "flex",
  alignItems: "center",
  gap: "10px",
  fontSize: "0.95rem",
};

const sectionHeader = { borderBottom: "2px solid #4CAF50", paddingBottom: "6px" };
const sectionHeaderBlue = { borderBottom: "2px solid #1976D2", paddingBottom: "6px" };
const sectionHeaderPurple = { borderBottom: "2px solid #9C27B0", paddingBottom: "6px" };
const sectionHeaderOrange = { borderBottom: "2px solid #FF9800", paddingBottom: "6px" };

const button = {
  padding: "14px",
  backgroundColor: "#2e7d32",
  color: "#fff",
  border: "none",
  borderRadius: "8px",
  fontWeight: "bold",
  cursor: "pointer",
  marginTop: "10px",
};

export default PostCleaningListing;
